import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const PhotosOutlined = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)" fill={color}>
      <Path d="M15.87 6.39H5.56A3.26 3.26 0 0 0 2.3 9.65v7.24c0 1.8 1.46 3.26 3.26 3.26h10.31c1.8 0 3.26-1.46 3.26-3.26V9.65c0-1.8-1.46-3.26-3.26-3.26ZM5.56 18.77c-.88 0-1.61-.61-1.82-1.42l3.25-4.66c.19-.28.46-.44.74-.45.26 0 .53.11.74.36l5.22 6.17H5.56Zm10.31 0h-.39l-2.75-3.25 1.47-1.45a.43.43 0 0 1 .34-.13c.13 0 .24.07.33.17l2.77 3.39c-.26.73-.95 1.26-1.77 1.26v.01Zm1.89-3.29-1.82-2.23c-.32-.4-.8-.64-1.31-.67-.51-.02-1.01.16-1.38.52l-1.4 1.38-2.34-2.76c-.48-.57-1.16-.88-1.85-.84-.71.03-1.36.41-1.8 1.04l-2.19 3.13v-5.4c0-1.04.85-1.89 1.88-1.89h10.32c1.04 0 1.89.85 1.89 1.89v5.83Z" />
      <Path d="M15.08 8.98a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Z" />
      <Path d="M18.43 4H8.11c-1.33 0-2.46.83-2.92 2h1.62c.32-.36.78-.6 1.3-.6h10.32c.96 0 1.74.78 1.74 1.74v6.72c0 .54-.26 1.02-.65 1.34v1.59c1.19-.45 2.05-1.59 2.05-2.93V7.14c0-1.73-1.41-3.14-3.14-3.14Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default PhotosOutlined
